import BaseResource from '@/lib/data/resource/BaseResource'

export default class AssetExposureResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.asset = payload.asset ?? {
      displayName  : payload?.selectedItem?.pair?.base?.displayName ?? '',
      displaySymbol: payload?.selectedItem?.pair?.base?.displaySymbol ?? '',
      name         : payload?.selectedItem?.pair?.base?.name ?? '',
      symbol       : payload?.selectedItem?.pair?.base?.symbol ?? '',
      type         : payload?.selectedItem?.pair?.base?.type ?? ''
    }
    this.assetCode = payload.assetCode ?? this.asset.symbol ?? ''
    this.code = payload.code ?? this.assetCode ?? ''
    this.name = payload.name ?? this.code ?? ''
    this.notional = payload.notional ?? ''
    this.label = payload.label ?? ''
    this.userProvidedSeasonality = payload.userProvidedSeasonality ?? false
    this.seasonality = payload.seasonality ?? new Array(12).fill('')
    this.selectedItem = payload.selectedItem ?? null
  }

  /* PROPERTIES */

  /* METHODS */
}
